(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('koozie-bundle-selector')) {
    customElements.define(
      'koozie-bundle-selector',
      class KoozieBundleSelector extends HTMLElement {
        connectedCallback() {
          this.options = Array.from(this.querySelectorAll('[data-quantity]'));
          this.setSize = parseInt(this.dataset.setSize, 10) || 2;

          this.onClick = this.onClick.bind(this);
          this.addEventListener('click', this.onClick);

          // The theme may re-render the product section (e.g. variant change)
          // and reset the real quantity input; keep the cards in step with it.
          this.observer = new MutationObserver(() => this.sync());
          const scope = this.closest('.shopify-section') || document.body;
          this.observer.observe(scope, { childList: true, subtree: true });

          // Variant-aware prices (non-Koozie cards only)
          this.variantData = this.readVariantData();
          if (this.variantData) {
            this.onVariantMaybeChanged = () => {
              setTimeout(() => this.sync(), 60);
              setTimeout(() => this.sync(), 400);
            };
            this.scope = this.closest('product-form-component') || this.closest('.shopify-section') || document;
            document.addEventListener('change', this.onVariantMaybeChanged, true);
            window.addEventListener('popstate', this.onVariantMaybeChanged);
            // Safety net in case the theme swaps variants without firing change events
            this.poll = setInterval(() => this.applyVariant(), 500);
          }

          this.sync();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
          if (this.observer) this.observer.disconnect();
          if (this.onVariantMaybeChanged) {
            document.removeEventListener('change', this.onVariantMaybeChanged, true);
            window.removeEventListener('popstate', this.onVariantMaybeChanged);
          }
          if (this.poll) clearInterval(this.poll);
        }

        readVariantData() {
          const el = this.querySelector('script[data-variant-prices]');
          if (!el) return null;
          try {
            return JSON.parse(el.textContent);
          } catch (e) {
            return null;
          }
        }

        currentVariantId() {
          const scope = this.closest('product-form-component') || this.closest('.shopify-section') || document;
          const idInput = scope.querySelector('input[name="id"]');
          if (idInput && idInput.value && this.variantData[idInput.value]) return idInput.value;
          const fromUrl = new URLSearchParams(window.location.search).get('variant');
          if (fromUrl && this.variantData[fromUrl]) return fromUrl;
          return null;
        }

        // Rewrites the card prices for the currently selected variant
        applyVariant() {
          if (!this.variantData) return;
          const id = this.currentVariantId();
          if (!id || id === this.appliedVariant) return;
          const data = this.variantData[id];
          if (!data) return;
          this.appliedVariant = id;

          this.options.forEach((option, index) => {
            const price = data.prices[index];
            if (!price) return;
            const total = option.querySelector('.koozie-bundle__total');
            const each = option.querySelector('.koozie-bundle__each');
            if (total) total.textContent = price.total;
            if (each) each.textContent = price.each + ' each';
            option.dataset.atcPrice = price.atc;
            option.disabled = !data.available;
          });

          const input = this.input;
          if (input) this.render(parseInt(input.value, 10) || parseInt(this.options[0].dataset.quantity, 10));
        }

        get input() {
          const wrapper = this.closest('.quantity-selector-wrapper');
          return wrapper ? wrapper.querySelector('input[name="quantity"]') : null;
        }

        onClick(event) {
          const option = event.target.closest('[data-quantity]');
          if (!option || option.disabled) return;
          this.setQuantity(parseInt(option.dataset.quantity, 10));
        }

        setQuantity(quantity) {
          const input = this.input;
          if (!input || !quantity) return;
          input.value = quantity;
          // Let the theme / apps know the quantity changed
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          this.render(quantity);
        }

        sync() {
          const input = this.input;
          if (!input) return;
          this.applyVariant();
          let quantity = parseInt(input.value, 10);
          const valid = this.options.some((o) => parseInt(o.dataset.quantity, 10) === quantity);
          if (!valid) {
            // Anything that is not a valid bundle snaps back to the first set
            quantity = parseInt(this.options[0].dataset.quantity, 10);
            input.value = quantity;
          }
          this.render(quantity);
        }

        render(quantity) {
          let selectedOption = null;
          this.options.forEach((option) => {
            const selected = parseInt(option.dataset.quantity, 10) === quantity;
            option.classList.toggle('is-selected', selected);
            option.setAttribute('aria-checked', selected ? 'true' : 'false');
            if (selected) selectedOption = option;
          });
          this.updateAddToCartPrice(selectedOption);
        }

        // Keeps the price in "Add to Cart — $xx.xx" in step with the selected card.
        // Only touches the text after the " — " separator, and only if it differs,
        // so it never loops with the MutationObserver.
        updateAddToCartPrice(option) {
          if (!option || !option.dataset.atcPrice) return;
          const scope = this.closest('product-form-component') || this.closest('.shopify-section');
          if (!scope) return;
          const label = scope.querySelector('.add-to-cart-text') || scope.querySelector('.add-to-cart-button');
          if (!label) return;

          const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            const separator = node.nodeValue.indexOf('\u2014'); // em dash
            if (separator === -1) continue;
            const updated = node.nodeValue.slice(0, separator + 1) + ' ' + option.dataset.atcPrice;
            if (node.nodeValue.trim() !== updated.trim()) node.nodeValue = updated;
            break;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
